import { useEffect, useState } from 'react';
import { Grid, Container, Typography, Card, CardContent } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';

import Navbar from '../Navbar';

import { ThemeClient } from '../contexts/Theme';
import { useCompany } from '../contexts/Company';

import CardImage from '../components/CardImage'
import Logo from '../components/Logo';

import Navegation from '../components/Navegation'

export default function VirtualLibrary() {
    const location = useLocation();
    const history = useHistory();
    const company = useCompany();

    const category = new URLSearchParams(location.search).get('category');
    const [currentCategory, setCurrentCategory] = useState(category);

    const [labels, setLabels] = useState({
        podcasts: 'Podcasts',
        articles: 'Artículos',
        videos: 'Videos',
        books: 'Libros',
        title: 'Biblioteca Virtual'
    });

    useEffect(() => {
        setCurrentCategory(category);
    }, [category]);

    useEffect(() => {
        console.log(company)
        if (company?.id == 45) {
            setLabels({
                podcasts: 'Podcasts',
                articles: 'Articles',
                videos: 'Videos',
                books: 'Books',
                title: 'Virtual Library'
            });
        } else {
            setLabels({
                podcasts: 'Podcasts',
                articles: 'Artículos',
                videos: 'Videos',
                books: 'Libros',
                title: 'Biblioteca Virtual'
            });
        }
    }, [company]);

    return (
        <ThemeClient>
            <Navbar title={labels.title} back={true} />

            <Logo
                style={{
                    height: 'auto',
                    maxWidth: '100%',
                    marginTop: '2rem',
                    marginBottom: '2rem',
                }}
            />

            <Container component="main" maxWidth="sm" sx={{ marginTop: 2 }}>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={6}>
                        <CardImage title={labels.podcasts} image='https://i.imgur.com/zaWtCfb.jpg' clickWrapper={(e) => history.push("/library?category=podcast")} />
                    </Grid>
                    <Grid item xs={6}>
                        <CardImage title={labels.articles} image='https://i.imgur.com/CjZoqze.jpg' clickWrapper={(e) => history.push("/library?category=article")} />
                    </Grid>
                    <Grid item xs={6}>
                        <CardImage title={labels.videos} image='https://i.imgur.com/58yPLff.jpg' clickWrapper={(e) => history.push("/library?category=youtube")} />
                    </Grid>
                    <Grid item xs={6}>
                        <CardImage title={labels.books} image='https://i.imgur.com/DXTHzkK.jpg' clickWrapper={(e) => history.push("/library?category=book")} />
                    </Grid>
                </Grid>

            </Container>
            <Navegation />
        </ThemeClient>
    );
};